import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss'],
})
export class PagenotfoundComponent implements OnInit {

  intervalClose: any;
  language: any;
  headerTitle: any;
  constructor(public navctrl: NavController, public http: HttpClient, public cmndecl: CommonDeclarationService) {
    this.checkserverUp();
    this.intervalClose='';
    this.language = localStorage.language;
    if(this.language == 'en')
      this.headerTitle = 'APPLICATION UNDER MAINTENANCE';
    else
    this.headerTitle = "एप्लीकेशन अंडर मेंटेनेंस";

  }

  ngOnInit() {

  }

  checkserverUp(){
    let req: any;
    console.log("checking");
    setTimeout(async ()=>{
      await this.http.post(this.cmndecl.baseUrl + this.cmndecl.versionUrl + this.cmndecl.apiUrl + "webbotInitsession",req).subscribe(data=>{
        console.log("SERVER IS UP");
        sessionStorage.CurrentPage = '/va/chat';
        this.navctrl.navigateRoot('/va/chat');
      },err=>{
        console.log(err);
        this.checkserverUp();
        console.log("still server is not up");
      })
    },4000);
  }
}
